// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCross = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M47.4678 44.8167L44.8162 47.4683C43.9436 48.341 42.8604 48.341 41.9878 47.4683C41.268 46.7485 37.6592 42.0061 31.9999 36.1115C26.3406 42.0061 22.7318 46.7485 22.012 47.4683C21.1393 48.341 20.0562 48.341 19.1836 47.4683L16.5319 44.8167C15.6593 43.9441 15.6593 42.8609 16.5319 41.9883C17.2517 41.2685 21.9942 37.6597 27.8887 32.0004C21.9942 26.3411 17.2517 22.7323 16.5319 22.0125C15.6593 21.1398 15.6593 20.0567 16.5319 19.1841L19.1836 16.5324C20.0562 15.6598 21.1393 15.6597 22.012 16.5324C22.7318 17.2522 26.3406 21.9947 31.9999 27.8892C37.6592 21.9947 41.268 17.2522 41.9878 16.5324C42.8604 15.6597 43.9436 15.6598 44.8162 16.5324L47.4678 19.1841C48.3405 20.0567 48.3405 21.1398 47.4678 22.0125C46.748 22.7323 42.0056 26.3411 36.1111 32.0004C42.0056 37.6597 46.748 41.2685 47.4678 41.9883C48.3405 42.8609 48.3405 43.9441 47.4678 44.8167Z" />
    </svg>
  );
};
